import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConvertDateService {

  constructor() { }

  convertDate(date: string, to: boolean = false): string {
    const dateSplit = date.toString().split(' ');
    const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    let numberOfMonth = (month.findIndex(item => item === dateSplit[1]) + 1).toString();

    numberOfMonth.length === 1 ?
      numberOfMonth = 0 + numberOfMonth :
      numberOfMonth = numberOfMonth.toString();

    const dateConvert = to ?
      [dateSplit[3], numberOfMonth, dateSplit[2]].join('-') + 'T' + '23:59:59' + '.000Z' :
      [dateSplit[3], numberOfMonth, dateSplit[2]].join('-') + 'T' + dateSplit[4] + '.000Z';


    return dateConvert;

  }



}
